import PropTypes from "prop-types";

import CALL_STATES from "../utils/states";

export const dialerProps = {
  callState: { callState: PropTypes.oneOf(Object.values(CALL_STATES)) },
  isRecording: { isRecording: PropTypes.bool },
  conference: { conference: PropTypes.shape({}) },
  startRecording: { startRecording: PropTypes.func },
  stopRecording: { stopRecording: PropTypes.func },
  setDuration: { setDuration: PropTypes.func },
  loading: { loading: PropTypes.bool },
  person: { person: PropTypes.shape({}) },
  phoneNumbers: { phoneNumbers: PropTypes.arrayOf(PropTypes.shape({})) },
  phoneNumber: { phoneNumber: PropTypes.shape({}) },
  callOutcome: { callOutcome: PropTypes.string },
  note: { note: PropTypes.string },
  setPhoneNumber: { setPhoneNumber: PropTypes.func },
  setCallState: { setCallState: PropTypes.func },
  setCallOutcome: { setCallOutcome: PropTypes.func },
  setComment: { setComment: PropTypes.func },
};

export const dialerDefaults = {
  callState: { callState: CALL_STATES.Ended },
  isRecording: { isRecording: false },
  conference: { conference: {} },
  startRecording: { startRecording: () => {} },
  stopRecording: { stopRecording: () => {} },
  setDuration: { setDuration: () => {} },
  loading: { loading: false },
  person: { person: {} },
  phoneNumbers: { phoneNumbers: [] },
  phoneNumber: { phoneNumber: {} },
  callOutcome: { callOutcome: null },
  note: { note: "" },
  setPhoneNumber: { setPhoneNumber: () => {} },
  setCallState: { setCallState: () => {} },
  setCallOutcome: { setCallOutcome: () => {} },
  setComment: { setComment: () => {} },
};
